// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
import i18next from 'i18next';

export default function getColumnHeaders(t: i18next.TFunction): any {
    return [
        {
            fieldName: 'firstName',
            name: t('first_name'),
            maxWidth: 120,
            minWidth: 100,
            width: 120,
            visible: true,
        },
        {
            fieldName: 'lastName',
            name: t('last_name'),
            maxWidth: 120,
            minWidth: 100,
            width: 120,
            visible: true,
        },
        {
            fieldName: 'email',
            name: t('email'),
            maxWidth: 200,
            minWidth: 200,
            width: 200,
            visible: true,
        },
        {
            fieldName: 'roleName',
            name: t('role'),
            maxWidth: 90,
            minWidth: 90,
            width: 90,
            visible: true,
        },
        {
            fieldName: 'tierName',
            name: t('tier_name'),
            maxWidth: 20,
            minWidth: 20,
            width: 50,
            visible: true,
        },
        {
            fieldName: 'soldtoCustomerName',
            name: t('sold_to'),
            maxWidth: 250,
            minWidth: 200,
            visible: false,
        },
        {
            fieldName: 'shiptoCustomerName',
            name: t('ship_to'),
            maxWidth: 250,
            minWidth: 200,
            visible: false,
        },
        {
            fieldName: 'actions',
            name: t('actions'),
            maxWidth: 110,
            minWidth: 110,
            width: 110,
            visible: true,
        },
        {
            fieldName: 'aadUserStatus',
            name: t('user_status'),
            maxWidth: 110,
            minWidth: 110,
            width: 110,
            visible: true,
        },
        {
            fieldName: 'requestAccess',
            name: t('request_access_back'),
            maxWidth: 400,
            minWidth: 340,
            width: 375,
            visible: true,
        },
        {
            fieldName: 'userStatus',
            name: t('status'),
            maxWidth: 110,
            minWidth: 110,
            visible: false,
        },
    ];
}